// extracted by mini-css-extract-plugin
export default {"message":"MessageCard_message__55WE+","container":"MessageCard_container__gIazZ"};